import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'environments/environment';
import { from } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { AuthService } from 'app/_utils/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class ClientsService {

  constructor(private http: HttpClient) { }

  private getUserId(): number {
    return Number(localStorage.getItem('0x100')) || 0;
  }

  getClients() {
    return from(AuthService.getAt()).pipe(
      switchMap(at => {
        const userId = this.getUserId();
        const url = `${environment.coreEndpoint}/user/${userId}/clients`;
        const headers = new HttpHeaders({ 'Authorization': `Bearer ${at}` });
        return this.http.get<{ status: boolean; data: any[] }>(url, { headers });
      }),
      map(response => response.data)
    );
  }
}
